/**
 * Composed selectors
 */

import { createSelector } from '@reduxjs/toolkit';
import { FeatureFlagName } from '../../../constants/features';
import { isFeatureFlagEnabled } from '../../../utilities/features';
import { keys } from '../../../utilities/serializable-map';
import { StoreStateSelector, isStatusSuccessful } from '../../selector/common';
import { getStatusForDiscoverProjectPermissions } from '../../selector/permission-selectors';
import { getProjectsFromDiscoveryServiceAuthorizedForEnvironmentRead } from '../../selector/project-from-discovery-service-selectors';
import {
    getProjectsAuthorizedForEnvironmentReadByDataPlaneId,
    getProjectsByDataPlaneId,
} from '../../selector/project-selectors';

/**
 * Composed selectors
 */

export const getIdsForProjectsRequiringEnvironments: StoreStateSelector<string[]> = createSelector(
    [
        getStatusForDiscoverProjectPermissions,
        getProjectsAuthorizedForEnvironmentReadByDataPlaneId,
        getProjectsByDataPlaneId,
        getProjectsFromDiscoveryServiceAuthorizedForEnvironmentRead,
    ],
    (
        discoverProjectPermissionsStatus,
        projectsAuthorizedForEnvironmentRead,
        allProjects,
        projectsFromDiscoveryServiceAuthorizedForEnvironmentRead
    ) => {
        const isDiscoveryFeatureFlagEnabled = isFeatureFlagEnabled(FeatureFlagName.EnableDiscoveryService);

        if (isDiscoveryFeatureFlagEnabled) {
            return keys(projectsFromDiscoveryServiceAuthorizedForEnvironmentRead);
        }

        // Still want to list environments if permission discovery fails, just try to list for all projects
        if (isStatusSuccessful(discoverProjectPermissionsStatus)) {
            return keys(projectsAuthorizedForEnvironmentRead);
        }

        return keys(allProjects);
    }
);
